export default __webpack_public_path__ + "static/media/HSImage.2e1da1a5.avif";